export default "__VITE_ASSET__61192c3a__"